export default __webpack_public_path__ + "static/media/piratenxhumanisten_quer_dunkel.922c860c.svg";